import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OneOnOneMeetingUrlService {

  private readonly oneOnOneMeetingBaseApi = '/api/one-on-one-meetings';
  
  constructor() { }

  getBaseUrl(){
    return this.oneOnOneMeetingBaseApi;
  }

  //This will be used for get by id and delete by id
  getByFieldUrl(field){
    return this.oneOnOneMeetingBaseApi+ this.getByField(field)
  }

  private getByField(field){
    return '/'+field;
  }


  getByParamUrl(params){
    let queryParamStr = '?'
    let i = 0
    Object.keys(params).forEach(function(key) {
      
      queryParamStr += (key + "=" +params[key])
      
      i++
      if (Object.keys(params).length > i)
        queryParamStr+='&'

     
     
    })
    
    return this.oneOnOneMeetingBaseApi + queryParamStr
  }
}
